var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 17.536 17.536 5 33 5C48.464 5 61 17.536 61 33C61 48.464 48.464 61 33 61C17.536 61 5 48.464 5 33Z",
    fill: "#D1FADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6663 31.9267V33C44.6649 35.5158 43.8503 37.9638 42.3439 39.9788C40.8375 41.9938 38.7202 43.4679 36.3076 44.1812C33.895 44.8945 31.3165 44.8089 28.9566 43.937C26.5966 43.0652 24.5818 41.4538 23.2125 39.3432C21.8432 37.2327 21.1928 34.7361 21.3583 32.2257C21.5238 29.7153 22.4964 27.3257 24.131 25.4133C25.7656 23.5008 27.9746 22.168 30.4286 21.6135C32.8825 21.0591 35.45 21.3127 37.748 22.3367M44.6663 23.6667L32.9997 35.345L29.4997 31.845",
    stroke: "#039855",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56C20.2975 56 10 45.7025 10 33H0C0 51.2254 14.7746 66 33 66V56ZM56 33C56 45.7025 45.7025 56 33 56V66C51.2254 66 66 51.2254 66 33H56ZM33 10C45.7025 10 56 20.2975 56 33H66C66 14.7746 51.2254 0 33 0V10ZM33 0C14.7746 0 0 14.7746 0 33H10C10 20.2975 20.2975 10 33 10V0Z",
    fill: "#ECFDF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerified);
export default __webpack_public_path__ + "static/media/email-verified.efc1ecc8c41529da575455c311ec8045.svg";
export { ForwardRef as ReactComponent };